<template>
  <div v-if="open" class="context-menu" :style="style" @click="onClick" @contextmenu.capture.prevent>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean,
      default: false
    },
    xyPosition: {
      type: Object
    }
  },
  computed: {
    style() {
      return this.open ? { top: `${this.top}px`, left: `${this.left}px` } : null;
    }
  },
  data() {
    return {
      top: null,
      left: null
    };
  },
  methods: {
    closeMenu() {
      if (!this.open) {
        return;
      }

      this.top = null;
      this.left = null;
    },
    onClick() {
      this.closeMenu();
    },
    openMenu() {
      this.$nextTick(() => {
        this.positionMenu(this.xyPosition.y, this.xyPosition.x);
        this.$el.focus();
      });
    },
    positionMenu (top, left) {
      const largestHeight = window.innerHeight - this.$el.offsetHeight - 25;
      const largestWidth = window.innerWidth - this.$el.offsetWidth - 25;
      if (top > largestHeight) {
        top = largestHeight;
      }
      if (left > largestWidth) {
        left = largestWidth;
      }
      this.top = top;
      this.left = left;
    }
  },
  watch: {
    xyPosition(value, oldValue) {
      if (!this.open || !value) {
          this.closeMenu();
          return;
      }

      this.openMenu();
    }
  }
};
</script>

<style scoped>
.context-menu {
  background: #fafafa;
  border: 1px solid #bdbdbd;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
  display: block;
  margin: 0;
  padding: 0;
  position: fixed;
  width: 150px;
  z-index: 99999;
}

.context-menu ul {
  list-style: none;
  padding: 0 0;
  margin: 0;
  font-size: 12px;
  font-weight: 600;
}

.context-menu li {
  list-style: none;
  padding: 10px 5px;
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.context-menu li:hover {
  background: #1e88e5;
  color: #fafafa;
}
</style>
